import { createAsyncThunk } from '@reduxjs/toolkit';
import { httpHelperV2 } from 'v2/services/httpHelper';

const assignTenderInquiryApprover = createAsyncThunk(
  'tender_inquiry/assignTenderInquiryApprover',
  ({ project_id, did, tenderId, data }) => {
    return httpHelperV2({
      url: `project/${project_id}/tender/${tenderId}/tender_inquiry/${did}/approvals`,
      method: 'POST',
      body: data,
    });
  },
);

const approveRejectInquiry = createAsyncThunk(
  'tender_inquiry/approveRejectInquiry',
  ({ project_id, did, tenderId, approver_id, data }) => {
    return httpHelperV2({
      url: `project/${project_id}/tender/${tenderId}/tender_inquiry/${did}/approval/${approver_id}`,
      method: 'PUT',
      body: data,
    });
  },
);

const acknowledgeRejectionFeedback = createAsyncThunk(
  'tender_inquiry/acknowledgeRejectionFeedback',
  ({ project_id, did}) => {
    return httpHelperV2({
      url: `project/${project_id}/tender_inquiry/${did}`,
      method: 'PATCH',
      body: {}
    });
  },
);

const sendTenderInquiryReminder = createAsyncThunk(
  'tender_inquiry/sendTenderInquiryReminder',
  ({ project_id, tender_id, tender_inquiry_id }) => {
    return httpHelperV2({
      url: `project/${project_id}/tender/${tender_id}/tender_inquiry/${tender_inquiry_id}/approvers`,
      method: 'POST',
    });
  },
);

export {
  assignTenderInquiryApprover ,
  approveRejectInquiry,
  acknowledgeRejectionFeedback,
  sendTenderInquiryReminder
};
